









import { Component, Vue, Prop } from "vue-property-decorator";
import { Project } from "@/models/project";

@Component({ name: "ProjectIdCard" })
export default class ProjectIdCard extends Vue {
  @Prop() readonly project!: Project;

  get title() {
      return this.project.name
  }

  get description() {
      return this.project.description
  }

  get subTitle() {
      return this.project.business_unit + " | Type: " + this.project.project_type
  }

  get customer() {
      return this.project.customer
  }
}
